import { render, staticRenderFns } from "./PromMan.vue?vue&type=template&id=a3e355ce&scoped=true"
import script from "./PromMan.vue?vue&type=script&lang=js"
export * from "./PromMan.vue?vue&type=script&lang=js"
import style0 from "./PromMan.vue?vue&type=style&index=0&id=a3e355ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e355ce",
  null
  
)

export default component.exports